module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento20+.6d2063e0.svg";